import { useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import WaitlistForm from "@/components/waitlist/waitlist-form";
import WaitlistConfirmation from "@/components/waitlist/waitlist-confirmation";

const waitlistSearchSchema = z.object({
  ref: z.string().optional(),
});

export const Route = createFileRoute("/_home/waitlist")({
  validateSearch: waitlistSearchSchema,
  component: WaitlistPage,
});

type WaitlistResult = {
  referralCode: string;
  alreadyRegistered: boolean;
  position?: number;
};

function WaitlistPage() {
  const { ref } = Route.useSearch();
  const [result, setResult] = useState<WaitlistResult | null>(null);

  const handleSuccess = (data: WaitlistResult) => {
    setResult(data);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background p-4">
      {result ? (
        <WaitlistConfirmation
          referralCode={result.referralCode}
          alreadyRegistered={result.alreadyRegistered}
          position={result.position}
        />
      ) : (
        <WaitlistForm
          initialReferralCode={ref}
          onSuccess={handleSuccess}
        />
      )}
    </div>
  );
}
